// home
export const SET_ALL_AREA = 'SET_ALL_AREA'
export const SET_MOUNT_PATH = 'SET_MOUNT_PATH'
export const SET_SOFTWARE = 'SET_SOFTWARE'
export const SET_DIALOG = 'SET_DIALOG'
export const SET_DIALOG_BUSINESS = 'SET_DIALOG_BUSINESS'
export const SET_UP_DIALOG = 'SET_UP_DIALOG'
export const SET_PROVINCE = 'SET_PROVINCE'
export const SET_CITYS = 'SET_CITYS'
export const SET_PLATFORMS = 'SET_PLATFORMS'
export const SET_ALL_PLATFORMS = 'SET_ALL_PLATFORMS'
export const SET_PERMISSION = 'SET_PERMISSION'
export const SET_USERINFO = 'SET_USERINFO'
export const SET_CONSTRAINT = 'SET_CONSTRAINT'
export const SET_COLUMN_FILTER = 'SET_COLUMN_FILTER'
export const SET_INIT_COLUMN_FILTER = 'SET_INIT_COLUMN_FILTER'
export const SET_CGLIST = 'SET_CGLIST'
export const UPDATE_DIALOG = 'UPDATE_DIALOG'
export const SET_ALL_TASK_CONSTRAINT = 'SET_ALL_TASK_CONSTRAINT'
export const SET_PLATFORM = 'SET_PLATFORM'
export const SET_PLUGIN = 'SET_PLUGIN'
export const SET_FULL_SPEED_DATA = 'SET_FULL_SPEED_DATA'
